module.exports = __webpack_public_path__ + "assets/img/nx-04.7355ca4a.jpg";